import script from "./IOrderMenuLegacy.vue?vue&type=script&setup=true&lang=ts"
export * from "./IOrderMenuLegacy.vue?vue&type=script&setup=true&lang=ts"

import "./IOrderMenuLegacy.vue?vue&type=style&index=0&id=d676ec9c&lang=scss"

const __exports__ = script;

export default __exports__